<div class="panel panel-flat">
    <div class="panel-heading">
        <h6 class="panel-title">Vendor Wise Unit Stations</h6>
    </div>

    <div class="card panel-body card-list-item card-border" [chart]="vendorWiseIndChart" *ngIf="graphPlot" [hidden]="getVendorLoader" style="height: 350px; min-width: 310px"></div>

    <!--<div [chart]="vendorWiseIndChart" style="height: 350px; min-width: 310px"></div>-->

    <div class="text-center" *ngIf="!graphPlot" [hidden]="getVendorLoader" style="height: 350px; min-width: 310px">
        <div class="label label-danger" style="margin-top: 100px;">No Unit Station Found</div>
    </div>

    <div style="height: 350px; text-align: center" [hidden]="!getVendorLoader">
        <img src="/assets/images/load.gif" />
    </div>
</div>
